import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/stores/auth';

export interface SchoolBrand { id: number; name: string; code: string | null; logo_url: string | null; motto: string | null; primary_color: string | null }

/** The signed-in user's school (name, logo, motto), fresh from /auth/me, so renames and new logos show at once. */
export function useSchool() {
  const user = useAuth((s) => s.user);
  const q = useQuery({
    queryKey: ['auth-me-school', user?.id],
    queryFn: () => api.get('/auth/me').then((r) => (r.data?.data?.school ?? null) as SchoolBrand | null),
    enabled: !!user?.schoolId,
    staleTime: 10 * 60 * 1000,
  });
  const school = q.data;
  return {
    name: school?.name ?? user?.schoolName ?? 'School',
    logo: school?.logo_url ?? null,
    motto: school?.motto ?? null,
    code: school?.code ?? user?.schoolCode ?? null,
    loading: q.isLoading,
  };
}
